import { useQuery } from "@tanstack/react-query";
import _ from "lodash";
import { getAgentDashboardMetrics } from "@/services";
import { getUserId } from "@/helpers";
import useAgentGitchaRestrictions from "./useAgentGitchaRestrictions";

const useAgentDashboardMetrics = (scope = "all") => {
  const userId = getUserId();
  const { shouldRestrictAgent } = useAgentGitchaRestrictions();

  const { data, isPending, error, refetch } = useQuery({
    queryKey: ["agentDashboardMetrics", { userId, scope, onlySyndicatedListings: shouldRestrictAgent }],
    queryFn: async () => {
      const response = await getAgentDashboardMetrics({
        userId,
        scope,
        onlySyndicatedListings: shouldRestrictAgent,
      });
      if (response?.errorCode !== 0) {
        throw response;
      }
      return _.get(response, "result", null);
    },
    enabled: !!userId,
    staleTime: 60_000,
  });

  return { data: data ?? null, loading: isPending, error: error ?? null, refetch };
};

export default useAgentDashboardMetrics;
